import i18n from '../i18n';
import { MailDataForNotificationInterface, MailBodyInterface } from '../types/interfaces';
import * as enums from '../types/enums';

const Domain = process.env.VUE_APP_FIREBASE_DOMAIN || 'https://localhost:5000';

/**
 * constructs an email with a body, title and a link to the relevant section
 * @param payload Contains the data needed for various email types
 * @returns The email object
 */
 const getMailDataForNotification = async (data: MailDataForNotificationInterface) => {
  const {
    documentId,
    sectionId,
    trigger,
    sectionOrArgumentContent,
    argumentId,
    documentTitle,
    userName,
    parentSectionContent,
    newSectionId
  } = data;
  let body: MailBodyInterface | undefined;
  let title: string | undefined;
  const documentUrl = `${Domain}/document/${documentId}`;
  const sectionPath = `/section?sectionById=${sectionId}`
  switch (trigger) {
    case enums.NOTIFICATION_TRIGGER.sectionApproval:
      title = i18n.t('mailNotification.sectionApproval.title').toString();
      body = {
        content: i18n.t('mailNotification.sectionApproval.content', {
          documentTitle,
          sectionContent: sectionOrArgumentContent
        }).toString(),
        linkLabel: i18n.t('mailNotification.sectionApproval.linkLabel').toString(),
        linkText: i18n.t('mailNotification.sectionApproval.linkText').toString(),
        url: `${documentUrl}/section/?sectionsByStatus=${enums.SECTION_STATUS.edited}&index=1&id=${sectionId}`,
      }
      break;
    case enums.NOTIFICATION_TRIGGER.argumentCreation:
      title = i18n.t('mailNotification.argumentCreation.title').toString();
      body = {
        content: i18n.t('mailNotification.argumentCreation.content', {
          argumentOrCommentOwnerUserName: userName,
          argumentOrCommentContent: sectionOrArgumentContent
        }).toString(),
        linkLabel: i18n.t('mailNotification.argumentCreation.linkLabel').toString(),
        linkText: i18n.t('mailNotification.argumentCreation.linkText').toString(),
        url: `${documentUrl}${sectionPath}&scrollTo=argument&scrollId=${argumentId}&index=1`,
      }
      break;
    case enums.NOTIFICATION_TRIGGER.sectionEdit:
      title = i18n.t('mailNotification.sectionEdit.title').toString();
      body = {
        content: i18n.t('mailNotification.sectionEdit.content', {
          sectionOwnerUserName: userName,
          parentSectionContent,
          sectionContent: sectionOrArgumentContent
        }).toString(),
        linkLabel: i18n.t('mailNotification.sectionEdit.linkLabel').toString(), 
        linkText: i18n.t('mailNotification.sectionEdit.linkText').toString(),
        url: `${documentUrl}/section?sectionById=${newSectionId}`,
      }
      break;
    case enums.NOTIFICATION_TRIGGER.sectionCreation:
      title = i18n.t('mailNotification.sectionCreation.title').toString();
      body = {
        content: i18n.t('mailNotification.sectionCreation.content', {
          sectionOwnerUserName: userName,
          documentTitle,
          sectionContent: sectionOrArgumentContent
        }).toString(),
        linkLabel: i18n.t('mailNotification.sectionCreation.linkLabel').toString(), 
        linkText: i18n.t('mailNotification.sectionCreation.linkText').toString(),
        url: `${documentUrl}${sectionPath}`,
      }
      break;
  }
  return {
    title,
    body,
  }
}

export default getMailDataForNotification;